import { ComponentType as s } from "../../registries/types/propTypes.js";
const g = (o) => {
  var e, r, n, l, t, c, i, m;
  return {
    themeColor: (r = (e = o.theme_color) == null ? void 0 : e.color) == null ? void 0 : r.color,
    themeShade: (l = (n = o.theme_color) == null ? void 0 : n.theme) == null ? void 0 : l.theme,
    backgroundColor: o.background_color,
    description: o.description,
    heading: o.heading,
    headingColor: o.heading_color,
    buttonBGColor: o.cta_background,
    image: (t = o.image) == null ? void 0 : t.images,
    buttonText: (c = o.link) == null ? void 0 : c.text,
    buttonTarget: (i = o.link) == null ? void 0 : i.target,
    buttonURL: (m = o.link) == null ? void 0 : m.url,
    descColor: o.descColor,
    borderColor: o.border_color
  };
}, p = (o) => ({
  componentType: s.featured_display_card,
  ...g(o)
});
export {
  p as default,
  g as displayCardTransformer
};
//# sourceMappingURL=featured-display-card-transformer.js.map
